// @ts-ignore
import React, { SourceHTMLAttributes, useEffect } from "react";

import { useIntl } from "react-intl";

import FeatureGates from "@atlaskit/feature-gate-js-client";
import { ProductKeys } from "@atlassiansox/asc-stargate";

import { CrossFlowTouchpointProvider } from "@/components/cross-flow/touchpoint";
import { IntercomProvider } from "@/libraries/intercom/src";
import { featureFlags, checkFeatureFlagGate } from "@/utils/feature-flags";

import { JiraProductDiscoveryTemplate } from "../../../../templates/software/jira/product-discovery/jira-product-discovery-software-page/src";

export const JiraProductDiscoveryPage = () => {
    const intl = useIntl();
    const isBootIntercom: boolean = checkFeatureFlagGate(
        featureFlags.gwp1304AddIntercomToJpdProductTour
    );
    useEffect(() => {
        FeatureGates.getLayer("wac-edge-track-routing-layer").get(
            "track",
            "main"
        );
    }, []);
    const intercomAppId = intl.locale === "ja" ? "p0ww63i2" : "";

    return (
        <IntercomProvider appId={intercomAppId} triggerBoot={isBootIntercom}>
            <CrossFlowTouchpointProvider
                screenName="wacJpdProductTourPage"
                productKeys={[ProductKeys.JIRA_PRODUCT_DISCOVERY]}
            >
                <JiraProductDiscoveryTemplate />
            </CrossFlowTouchpointProvider>
        </IntercomProvider>
    );
};
